import { IAppointmentDto } from "modules/appointment/Dtos/IAppointmentDto";

export const createAppointment = (
  appointment?: IAppointmentDto
): IAppointmentDto => {
  return {
    id: "12345678",
    startDate: "2021-2-27",
    endDate: "2021-2-27",
    queueId: "eeee-ffff-qqqq-0",
    groupId: "rrrr-tttt-yyyy-1",
    ...appointment,
  };
};
